import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateUserGroup } from "../../models/admin/CreateUserGroup";
import { UpdateUserGroup } from "../../models/admin/UpdateUserGroup";

const RESOURCE_NAME = "usergroup";

const getAll = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}`, requestConfig());
};

const create = (model: CreateUserGroup) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const update = (model: UpdateUserGroup) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${model.Id}`, model, requestConfig());
};

const remove = (id: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
};

const UserGroupService = {
  getAll,
  create,
  update,
  remove,
};
export default UserGroupService;
